<template>
  <div
    class="voucher d-flex"
    :style="{
      background: 'url(' + voucherImage + ') center center / contain no-repeat ',
      opacity: !isAvailable ? 0.7 : 1,
      cursor: !isAvailable ? 'not-allowed' : 'pointer'
    }"
    @click="routeToDetail"
    :disabled="!isAvailable"
  >
    <div class="voucher-left px-5 pt-5 pb-7">
      <v-container class="voucher-item">
        <div v-if="discountPercentage !== 0" class="discount font-weight-bold primary lighten-1 d-flex flex-column align-center justify-center white--text rounded-circle">
          <span>{{ discountPercentage }}%</span>
          <span>{{ $t('label.discountOff') }}</span>
        </div>
        <v-row class="voucher-title mb-1 primary--text text--darken-1">
          <v-col>{{ voucherTitle }}</v-col>
        </v-row>

        <v-row dense class="voucher-details">
          <v-col class="py-0 grey--text font-weight-medium">{{ $t('label.value') }}</v-col>
          <v-col class="py-0 font-weight-medium">{{ voucherValue }}</v-col>
        </v-row>

        <v-row dense class="voucher-details" v-if="voucherRetailPrice">
          <v-col class="py-0 grey--text font-weight-medium">{{ $t('label.retailPrice') }}</v-col>
          <v-col class="py-0 font-weight-medium">
            <span v-if="voucherDiscountPrice">{{ currency }}{{ formatPrice(voucherDiscountPrice) }}</span>
            <span
              v-if="voucherRetailPrice"
              :class="{
                'text-decoration-line-through ml-1': voucherDiscountPrice
              }"
            >
              {{ currency }}{{ formatPrice(voucherRetailPrice) }}
            </span>
          </v-col>
        </v-row>

        <v-row dense class="voucher-details" v-if="voucherExpiry">
          <v-col class="py-0 grey--text font-weight-medium">{{ $t('label.expiryDate') }}</v-col>
          <v-col class="py-0 font-weight-medium">
            <span>{{ voucherExpiry | shortDate }}</span>
          </v-col>
        </v-row>

        <v-row dense class="voucher-details" style="height: 20px" v-if="voucherPartnerPrice">
          <v-col class="py-0 orange--text font-weight-medium">{{ voucherPartnerPrice !== 0 ? $t('label.partnerPrice') : `\n` }}</v-col>
          <v-col class="py-0 orange--text font-weight-medium">{{ voucherPartnerPrice !== 0 ? `${currency} ${formatPrice(voucherPartnerPrice)}` : '' }}</v-col>
        </v-row>

        <v-row dense class="voucher-details">
          <v-col class="primary--text text--darken-1">{{ $t('button.details') }} ></v-col>
        </v-row>
      </v-container>
      <div v-if="!isAvailable" class="sold-out-label pa-2 font-weight-bold secondary lighten-1 text-center white--text rounded-pill">
        <span>{{ $t('label.soldOut') }}</span>
      </div>
    </div>
    <!-- <div class="voucher-right d-flex justify-center align-center"
            v-bind:class="{'primary lighten-1' : true}">
            <p class="voucher-type">Discount Voucher</p>
        </div>         -->
  </div>
</template>

<script>
import router from '@/router'
import i18n from '@/plugins/i18n'
import { ROUTE_NAME } from '@/constants/route.constants'
import { uiHelper } from '@/utils'

export default {
  name: 'VouchersTicket',
  components: {},
  props: {
    productId: {
      type: Number,
      required: true
    },
    isAvailable: {
      type: Boolean,
      required: true
    },
    currency: {
      type: String,
      required: true
    },
    voucherTitle: {
      type: String
    },
    voucherValue: {
      type: String
    },
    discountPercentage: {
      type: Number
    },
    voucherDiscountPrice: {
      type: Number
    },
    voucherRetailPrice: {
      type: Number
    },
    voucherPartnerPrice: {
      type: Number
    },
    voucherExpiry: {
      default: '31 Dec 2020'
    },
    voucherType: {
      default: 'Discount Voucher'
    },
    isHistory: {
      type: Boolean,
      default: false
    },
    voucherDetail: {
      type: Object
    }
  },
  data() {
    return {}
  },
  computed: {
    voucherImage() {
      let voucherImage = ''
      switch (this.voucherType) {
        case 'Cash Voucher':
          voucherImage = `/images/voucher-type/${i18n.locale}/cash-voucher.svg`
          break
        case 'One-Time Voucher':
        case 'One Time Voucher':
          voucherImage = `/images/voucher-type/${i18n.locale}/one-time-voucher.svg`
          break
        case 'Discount Voucher':
        default:
          voucherImage = `/images/voucher-type/${i18n.locale}/discount-voucher.svg`
      }
      console.log('V I', voucherImage)
      return voucherImage
    }
  },
  methods: {
    routeToDetail() {
      if (this.isAvailable) {
        if (this.isHistory) router.push({ name: ROUTE_NAME.WALLET_VOUCHER_DETAILS, params: { voucher: this.voucherDetail } })
        else router.push({ name: ROUTE_NAME.PRODUCT_DETAIL, params: { productId: this.productId } })
      }
      // this.isAvailable && router.push({ name: ROUTE_NAME.PRODUCT_DETAIL, params: { productId: this.productId } })
    },
    formatPrice(val) {
      return uiHelper.priceFormatter(val)
    }
  }
}
</script>

<style lang="scss" scoped>
.voucher-item {
  position: relative;
}

.voucher {
  cursor: pointer;
  min-width: 350px;
  max-width: 420px;
}

.voucher-left,
.voucher-right,
.voucher {
  position: relative;
  overflow: hidden;
}

.voucher-left {
  width: 83%;
}

.voucher-title {
  font-weight: 700;
  font-size: 14px;
}

.voucher-details {
  font-size: 11px;
}

.sold-out-label {
  position: absolute;
  width: 60%;
  height: 40px;
  left: 20%;
  top: 35%;
}

.discount {
  position: absolute;
  right: 4%;
  top: 3%;
  height: 40px;
  width: 40px;
  font-size: 0.75rem;
  line-height: 1;

  @media only screen and (min-width: 640px) {
    height: 50px;
    width: 50px;
    font-size: 0.8rem;
  }
  @media only screen and (min-width: 1800px) {
    height: 50px;
    width: 50px;
    font-size: 0.8rem;
  }
}

/* .voucher-right {
    width: 17%;
}

.voucher-left::before, .voucher-left::after, .voucher-right::before, .voucher-right::after {
    content: "";
    position: absolute;
    width: 30px;
    height: 30px;
    background-color: var(--v-background-base);
    border-radius: 50%;
}

.voucher-left::before {
    bottom: -15px;
    right: -15px;   
}

.voucher-left::after {
    top: -15px;
    right: -15px;    
}

.voucher-right::after {
    top: -15px;
    left: -15px;    
}

.voucher-right::before {
    bottom: -15px;
    left: -15px;    
} */

/* .voucher-type{
    width: 100px;
    position: absolute;
    transform: rotate(-90deg) translate(0, 34%);
    font-size: 11px;
    color: #fff;
} */
</style>
